import * as dateFnsCompat from 'utils/date-fns-compat';

import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { FiCheck } from "react-icons/fi";
import { MdErrorOutline } from "react-icons/md";
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import Spinner from 'react-spinkit';
import { compose, lifecycle, withHandlers, withProps, withStateHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import {
  AdminTaskStatus,
  AdminTaskType,
  dateFormats,
  getTasaApproval,
  kaplanCpdType,
  kaplanMapping,
  routes,
  TaskStatus,
  getTasaApproval2022,
  kaplanMapping2022,
  isRMCPDGoal2022,
  kaplanAccreditationDetails2022,
  pre2022TemplateColumns,
  pre2022TemplateRows,
  templateColumns,
  requiredTemplateColumns,
  requiredPre2022TemplateColumns,
} from '../../../../constants';
import { modeOfLearning } from '../../../../constants/mode-of-learning';
import { adminActions } from '../../../../state/modules/admin';
import { downloadBlobStreamFile, getBlobStream, getCsvStream, pluralise, writeDataToCsvStream } from '../../../../utils';
import { ConfirmationModal, FileUploadFormField, GeneralTable, LoadingButton } from '../../../components';
import Loading from '../../loading';
import { format } from 'date-fns'
import UploadProgressModal from './partial/upload-progress-modal';
import { kaplanHistoryUploadMode } from './cpd-point';

const uuidv1 = require('uuid/v1');
const csv = require('csvtojson')

const kaplanReportField = {
  firstName: 'first name',
  lastName: 'last name',
  email: 'email address',
  activityId: 'activity ad',
  date: 'date of activity',
  name: 'name of activity',
  provider: 'activity conducted by'
};

const kaplanReportField2022 = {
  firstName: 'first name',
  middleName: 'middle name',
  lastName: 'last name',
  email: 'email',
  activityId: 'activity id',
  date: 'completion date',
  name: 'activity name',
  provider: 'provider name',
  totalPoints: 'total (hours)',
};

const parseRow = (mode,row) => {
  const isPre2022 = mode === kaplanHistoryUploadMode.modePre2022;
  const mapping = isPre2022 ? kaplanMapping : kaplanMapping2022;
  const reportField = isPre2022 ? kaplanReportField : kaplanReportField2022;

  const allCpdPoints = Object.keys(mapping).map((key) => {
    const pointsRaw = row[key.toLowerCase()];
    const points =
      pointsRaw !== undefined && pointsRaw !== null
        ? parseFloat(pointsRaw)
        : undefined;
    return { name: key, points };
  });
  const cpdPointsToImport = allCpdPoints.filter(
    ({ points }) => typeof points === 'number' && !isNaN(points)
  );

  const dateString = row[reportField.date];
  const [dayStr, monthStr, yearStr] = (dateString || '').split('/');
  const day = parseInt(dayStr, 10);
  const month = parseInt(monthStr, 10) - 1;
  const rawYear = parseInt(yearStr, 10);
  const year = rawYear > 2000 ? rawYear : rawYear + 2000;
  const date = new Date(year, month, day);

  const base = {
    identifier: uuidv1(),
    firstName: row[reportField.firstName],
    lastName: isPre2022
      ? row[reportField.lastName]
      : row[reportField.lastName] + (row[reportField.middleName] || ''),
    id: row[reportField.activityId],
    name: row[reportField.name],
    email: row[reportField.email],
    date,
    cpdPoints: cpdPointsToImport,
    cpdCategoryPoints: [],
    description: '',
    provider: row[reportField.provider],
    validated: false
  };

  if (isPre2022) {
    return {
      ...base,
      tpbApproved: getTasaApproval(row)
    };
  } else {
    const accreditationDetails = Object.values(kaplanAccreditationDetails2022)
      .map((key) => {
        const lowerKey = key.toLowerCase();
        const number = row[lowerKey];
        const points = row[`${lowerKey} hours`];
        return {
          name: key,
          number,
          points: points ? parseFloat(points, 10) : undefined
        };
      })
      .filter(({ points }) => points !== undefined);

    return {
      ...base,
      tpbApproved: getTasaApproval2022(row),
      isRMCPD: isRMCPDGoal2022(row),
      totalPoints: row[reportField.totalPoints],
      accreditationDetails
    };
  }
};

const onCsvDrop =
  ({ mode,errorMessages, setParsingFile, setParsed, setCsvFile , setErrorMessages}) =>
  (acceptedFiles, rejectedFiles) => {
    setParsingFile(true);
    const acceptedFile = Array.isArray(acceptedFiles)
      ? acceptedFiles[0]
      : undefined;

    const rejectedFile = Array.isArray(rejectedFiles)
      ? rejectedFiles[0]
      : undefined;

    if (acceptedFile instanceof File) {
      const reader = new FileReader();
      reader.onload = () => {
        const fileContent =
          typeof reader.result === 'string' ? reader.result : '';

        csv()
          .fromString(fileContent)
          .then((csvJson) => {
       

            const normalizedCsv = csvJson.flatMap((row) => {
              if (!row || typeof row !== 'object') return [];
              return [
                Object.fromEntries(
                  Object.entries(row).map(([k, v]) => [k.toLowerCase(), v])
                )
              ];
            });

            const parsed = normalizedCsv.map((row) => parseRow(mode, row));

            const filtered = parsed.filter(
              ({ cpdPoints }) =>
                Array.isArray(cpdPoints) && cpdPoints.length > 0
            );
            setParsed(filtered);
            setParsingFile(false);
          
            const requiredHeaders = Object.keys(
              mode === kaplanHistoryUploadMode.modePre2022
                ? requiredPre2022TemplateColumns
                : requiredTemplateColumns
            ).map((v) => v.toLowerCase());
            const csvHeaders = Object.keys(csvJson[0])
              .filter((v) => !/^field\d+$/i.test(v))
              .map((v) => v.toLowerCase());
            const missingRequiredHeaders = requiredHeaders.filter(
              (requiredHeader) => !csvHeaders.includes(requiredHeader)
            );

        
            setErrorMessages({
              ...errorMessages,
              missingHeaderMsg:
                missingRequiredHeaders.length > 0
                  ? [
                      `Found ${
                        missingRequiredHeaders.length
                      } missing required header/s. [${missingRequiredHeaders.toString()}]`
                    ]
                  : []
            });
          })
          .catch((err) => {
            console.error('CSV parse error:', err);
            setParsingFile(false);
          });
      };

      reader.readAsText(acceptedFile);
      setCsvFile(acceptedFile, undefined);
    }

    if (rejectedFile) {
      return setCsvFile(undefined, 'This file cannot be read');
    }
  };

const KaplanHistoryUpload = ({
  mode,
  csvFile,
  setCsvFile,
  setParsed,
  validatedEntries,
  isUploading,
  showConfirmation,
  toggleConfirmation,
  isFetchingUsers,
  usersForUpload,
  confirmationUserPoints,
  confirmUserNames,
  initUploadTasks,
  progress,
  setParsingFile,
  isParsingFile,
  uploadProgressDetails,
  parsed,
  exportTemplate,
  toggleErrorDropDown,
  errorDropDownIsOpen,
  errorMessages,
  setErrorMessages
}) => {
  const columns = [
    {
      key: 'taskStatus',
      name: (
        <div>
          {`Upload${progress}`}
          <UploadProgressModal details={uploadProgressDetails} />
        </div>
      )
    },
    {
      key: 'user',
      name: 'User'
    },
    {
      key: 'activity',
      name: 'Activity'
    },
    {
      key: 'tpb',
      name: 'TPB'
    },
    {
      key: 'description',
      name: 'Details'
    }
  ];

  const fileTooLong = validatedEntries && validatedEntries.length > 100;
  const shownEntries = fileTooLong ? [] : validatedEntries;
  const rows = fp.flow(
    fp.map(
      ({
        taskStatus,
        provider,
        firstName,
        lastName,
        id,
        name,
        email,
        date,
        cpdPoints,
        totalPoints,
        cpdCategoryPoints,
        description,
        tpbApproved
      }) => {
        const cpdPointRows = fp.map(({ name, points }) => {
          return <li key={name}>{`${name} - ${points}`}</li>;
        })(cpdPoints);

        const cpdCategoryPointRows = fp.map(({ cpdCategoryName, points }) => {
          return (
            <li key={cpdCategoryName}>{`${cpdCategoryName} - ${points}`}</li>
          );
        })(cpdCategoryPoints);

        const activityTotalPoints =
          mode === kaplanHistoryUploadMode.modePre2022
            ? fp.sumBy('points')(cpdPoints) +
              fp.sumBy('points')(cpdCategoryPoints)
            : totalPoints;

        const getTaskStatusIcon = () => {
          if (taskStatus === TaskStatus.updating) {
            return <Spinner name='circle' className='spinner' fadeIn='none' />;
          }
          if (taskStatus === TaskStatus.completed) {
            return <FiCheck />;
          }
          if (taskStatus === TaskStatus.failed) {
            return <MdErrorOutline className='error-icon' />;
          }
        };

        return {
          taskStatus: {
            value: getTaskStatusIcon()
          },
          user: {
            value: (
              <div>
                <div>
                  <strong>Name:</strong>
                  {` ${firstName} ${lastName}`}
                </div>
                <div>
                  <strong>Email:</strong>
                  {` ${email}`}
                </div>
              </div>
            )
          },
          activity: {
            value: (
              <div>
                <div>
                  <strong>Name:</strong>
                  {` ${name}`}
                </div>
                <div>
                  <strong>Provider:</strong>
                  {` ${provider}`}
                </div>
                <div>
                  <strong>Accreditation Number:</strong>
                  {` ${id}`}
                </div>
                <div>
                  <strong>Total Points:</strong>
                  {` ${activityTotalPoints}`}
                </div>
                <div>
                  <strong>Date:</strong>
                  {` ${dateFnsCompat.format(date, dateFormats.ShortDate)}`}
                </div>
                <div>
                  <strong>Description:</strong>
                  {` ${description}`}
                </div>
              </div>
            )
          },
          tpb: {
            value: tpbApproved ? 'Yes' : 'No',
            className: 'tpb'
          },
          description: {
            value: (
              <div>
                <h3>CPD point break down</h3>
                <ul>
                  {cpdPointRows}
                  {cpdCategoryPointRows}
                </ul>
              </div>
            ),
            className: 'notes'
          }
        };
      }
    )
  )(shownEntries);

  const uploadConfirmationMessage = isFetchingUsers ? (
    <Loading />
  ) : usersForUpload.length === 0 ? (
    <div>Failed to find a caddie user for your upload</div>
  ) : (
    <div>
      <p>You are about to upload:</p>
      <div>
        {fp.map(({ fullName, email, externalCpds }) => (
          <p key={email}>{`${externalCpds.length} external CPD ${pluralise(
            'record',
            externalCpds.length
          )} to ${fullName} (${email})`}</p>
        ))(confirmationUserPoints)}
      </div>
      <div>
        {confirmUserNames.length > 0 ? (
          <h3 className='warning-text'>Warning</h3>
        ) : null}
        <div>
          {fp.map((message) => (
            <p key={message} className='warning-text'>
              {message}
            </p>
          ))(confirmUserNames)}
        </div>
      </div>
    </div>
  );

  /**
   * Returns the row numbers (1-based index) of entries in `shownEntries` that have an invalid or missing date.
   *
   * @example
   * // If shownEntries = [{ date: new Date('invalid') }, { date: new Date() }]
   * // rowsWithMissingDates = [1]
   *
   * @type {number[]}
   */
  const rowsWithMissingDates = shownEntries.flatMap((v, i) =>
    isNaN(v.date.getTime()) ? [i + 1] : []
  );

  const allErrorMessages = [
    ...Object.values(errorMessages).flat(),
    ...(rowsWithMissingDates.length > 0
      ? [
          `Found ${
            rowsWithMissingDates.length
          } missing date/s. Missing date in row/s: [${rowsWithMissingDates.toString()}]`
        ]
      : [])
  ];

  return (
    <div id='kaplan-upload'>
      <h2>Kaplan History Upload ({mode})</h2>
      <form>
        <Row className='no-gutter'>
          <Button onClick={exportTemplate}>Download template</Button>
        </Row>
        <Row className='no-gutter'>
          <FileUploadFormField
            styleName={`kaplan-history-file-${mode}`}
            accept='.csv'
            multiple={false}
            onFileDrop={onCsvDrop({
              mode,
              errorMessages,
              setParsingFile,
              setParsed,
              setCsvFile,
              setErrorMessages
            })}
            file={csvFile}
            dropLabel='Upload CSV file'
          />
        </Row>
        {csvFile !== undefined && allErrorMessages.length > 0 ? (
          <Row className='no-gutter'>
            <Col>
              <div className='kaplan-error-box'>
                <div
                  className='kaplan-error-header'
                  onClick={toggleErrorDropDown}
                >
                  <span role='img' aria-label='error'>
                    🚫
                  </span>
                  Errors ({allErrorMessages.length})
                </div>
                {errorDropDownIsOpen && (
                  <ul className='kaplan-error-list'>
                    {allErrorMessages.map((errorMessage, index) => (
                      <li key={index}>{errorMessage}</li>
                    ))}
                  </ul>
                )}
              </div>
            </Col>
          </Row>
        ) : null}
        <Row className='no-gutter'>
          {validatedEntries.length > 0 ? (
            <Col>
              <LoadingButton
                key={showConfirmation}
                loading={isUploading}
                text='Send to admin task queue'
                disabled={allErrorMessages.length > 0}
                onClick={toggleConfirmation}
              />
              <LinkContainer
                className='right'
                to={routes.adminPortal.adminTaskGroup}
              >
                <Button>View admin task queue</Button>
              </LinkContainer>
            </Col>
          ) : null}
          <Col>
            <h3>CPD points to upload</h3>
          </Col>
          <Col>
            {isFetchingUsers || isParsingFile ? (
              <Loading />
            ) : (
              <GeneralTable
                className='kaplan-upload-table'
                columns={columns}
                rows={rows}
              />
            )}
          </Col>
          <ConfirmationModal
            id='confirm-kaplan-upload'
            show={showConfirmation}
            actions={[
              {
                onConfirmAction: () => {
                  toggleConfirmation();
                  initUploadTasks();
                },
                actionLabel: 'Yes',
                hideActionButton: usersForUpload.length === 0
              }
            ]}
            cancel={() => toggleConfirmation()}
            message={uploadConfirmationMessage}
            headingText={<span>Upload Kaplan CPD Points</span>}
          />
        </Row>
      </form>
    </div>
  );
};

const mapFaseaCpdPoints = (entry, industries, userProfiles, mode) => {
  // We map the kaplan categories to our caddie categories here.
  // If the categories is updated, make sure we did the correct mapping.
  if (mode === kaplanHistoryUploadMode.modePre2022) {
    const {
      email,
      cpdPoints
    } = entry
    const userProfile = fp.find(
      ({ user }) => fp.lowerCase(user.email) === fp.lowerCase(email)
    )(userProfiles)
    const userIndustryCpdCategories = fp.flow(
      fp.get('trainingPlans'),
      fp.map(
        ({ industry }) => {
          const industryCpdCategorys = fp.flow(
            fp.find(
              (industryWithCpdCategory) => industryWithCpdCategory.industry.id === industry.id
            ),
            fp.get('cpdCategorys'),
            fp.map(
              (cpdCategory) => ({
                ...cpdCategory,
                name: he.decode(cpdCategory.name)
              })
            )
          )(industries)
          return industryCpdCategorys
        }
      ),
      fp.flatten,
    )(userProfile)
  
    const allCpdPoints = fp.flow(
      fp.map(
        ({ name, points }) => {
          const mapped = kaplanMapping[name]
          const cpdCategory = fp.find(
            (userCpdCategory) => userCpdCategory.name === fp.get('name')(mapped)
          )(userIndustryCpdCategories)
          return {
            kaplanName: name,
            type: fp.get('type')(mapped),
            cpdCategory,
            points
          }
        }
      )
    )(cpdPoints)
  
    const mappedCpdPoints = fp.flow(
      fp.map(
        ({ id, name }) => {
          const points = fp.flow(
            fp.filter(
              ({ cpdCategory, type }) => (fp.get('name')(cpdCategory) === name) && (type === kaplanCpdType.import)
            ),
            fp.sumBy('points')
          )(allCpdPoints)
          return {
            cpdCategoryId: id,
            cpdCategoryName: name,
            points
          }
        }
      ),
      fp.filter(
        ({ points }) => {
          return points > 0
        }
      )
    )(userIndustryCpdCategories)
  
    const documentedCpdPoints = fp.flow(
      fp.filter(({ type }) => type === kaplanCpdType.document),
      fp.map(({kaplanName, points}) => ({name: kaplanName, points})),
    )(allCpdPoints);
  
    const documentedCpdPointDescriptions = documentedCpdPoints.map(
      ({ name, points }) => `${points} ${pluralise('point', points)} in ${name}`
    );
  
    return {
      ...entry,
      description: fp.isEmpty(documentedCpdPointDescriptions) ? '' : `Points imported includes, ${documentedCpdPointDescriptions.join(',')}.`,
      cpdPoints: documentedCpdPoints,
      cpdCategoryPoints: mappedCpdPoints
    }
  } else { // when mode is kaplanHistoryUploadMode.mode2022
    const {
      email,
      cpdPoints,
      accreditationDetails,
    } = entry
    const userProfile = fp.find(
      ({ user }) => fp.lowerCase(user.email) === fp.lowerCase(email)
    )(userProfiles)
    const userIndustryCpdCategories = fp.flow(
      fp.get('trainingPlans'),
      fp.map(
        ({ industry }) => {
          const industryCpdCategorys = fp.flow(
            fp.find(
              (industryWithCpdCategory) => industryWithCpdCategory.industry.id === industry.id
            ),
            fp.get('cpdCategorys'),
            fp.map(
              (cpdCategory) => ({
                ...cpdCategory,
                name: he.decode(cpdCategory.name)
              })
            )
          )(industries)
          return industryCpdCategorys
        }
      ),
      fp.flatten,
    )(userProfile)
  
    const allCpdPoints = fp.flow(
      fp.map(
        ({ name, points }) => {
          const mapped = kaplanMapping2022[name]
          const cpdCategory = fp.find(
            (userCpdCategory) => userCpdCategory.name === fp.get('name')(mapped)
          )(userIndustryCpdCategories)
          return {
            kaplanName: name,
            type: fp.get('type')(mapped),
            cpdCategory,
            points
          }
        }
      )
    )(cpdPoints)
  
    const mappedCpdPoints = fp.flow(
      fp.map(
        ({ id, name }) => {
          const points = fp.flow(
            fp.filter(
              ({ cpdCategory, type }) => (fp.get('name')(cpdCategory) === name) && (type === kaplanCpdType.import)
            ),
            fp.sumBy('points')
          )(allCpdPoints)
          return {
            cpdCategoryId: id,
            cpdCategoryName: name,
            points
          }
        }
      ),
      fp.filter(
        ({ points }) => {
          return points > 0
        }
      )
    )(userIndustryCpdCategories)
  
    const documentedCpdPoints = fp.flow(
      fp.filter(({ type }) => type === kaplanCpdType.document),
      fp.map(({kaplanName, points}) => ({name: kaplanName, points})),
    )(allCpdPoints);
  
    const documentedCpdPointDescriptionArray = documentedCpdPoints.map(
      ({ name, points }) => `${points} ${pluralise('point', points)} in ${name}`
    );
  
    const documentedCpdPointDescription = fp.isEmpty(documentedCpdPointDescriptionArray) 
      ? '' 
      : `Points imported includes, ${documentedCpdPointDescriptionArray.join(', ')}. `;
  
    const accreditationDetailsDescriptionArray = accreditationDetails.map(
      ({ name, number, points }) => `${points} ${pluralise('point', points)} in ${name}${number && ` - ${number}`}`
    );
  
    const accreditationDetailsDescription = fp.isEmpty(accreditationDetailsDescriptionArray) 
      ? ''
      : `Accreditation details imported includes, ${accreditationDetailsDescriptionArray.join(', ')}.`;
  
    return {
      ...entry,
      description: documentedCpdPointDescription + accreditationDetailsDescription,
      cpdPoints: documentedCpdPoints,
      cpdCategoryPoints: mappedCpdPoints
    }
  }
}

const mapStateToProps = ({ cpdCategorys, admin, industry, ...state }) => ({
  allCpdCategories: cpdCategorys.cpdCategorys,
  isUploading: admin.isUpdatingTask,
  usersForUpload: admin.usersForKaplanUpload,
  isFetchingUsers: admin.isFetchingUser,
  industries: industry.industriesWithCpdCategorys,
  adminTaskGroup: admin.adminTaskGroup,
  isCreatingTaskGroup: admin.isUpdatingTaskGroup,
})
const mapDispatchToProps = (dispatch) => ({
  upload: bindActionCreators(adminActions.admin.addTask, dispatch),
  createTaskGroup: bindActionCreators(adminActions.admin.addTaskGroup, dispatch),
  getUsersFromEmails: bindActionCreators(adminActions.admin.getUsersFromEmails, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(({ industries }) => {
    const allGoals = fp.flow(fp.flatMap('goals'), fp.uniqBy('id'))(industries);
    return {
      allGoals
    };
  }),
  withStateHandlers(
    {
      parsed: undefined,
      csvFile: undefined,
      validation: undefined,
      showConfirmation: false,
      isParsingFile: false,
      errorDropDownIsOpen: true,
      /**
       * Object to hold error messages related to CSV parsing
       *
       * @example
       * {
       *   missingHeaderMsg: [
       *     "Found 2 missing required headers: [header1, header2]"
       *   ]
       * }
       */
      errorMessages: {}
    },
    {
      setParsingFile: () => (isParsingFile) => ({
        isParsingFile
      }),
      setCsvFile: () => (csvFile, validation) => ({
        csvFile,
        validation
      }),
      setParsed: () => (parsed) => ({
        parsed
      }),
      setErrorMessages: () => (errorMessages) => ({
        errorMessages
      }),
      toggleErrorDropDown:
        ({ errorDropDownIsOpen }) =>
        () => ({ errorDropDownIsOpen: !errorDropDownIsOpen }),
      toggleConfirmation:
        ({ showConfirmation }) =>
        () => ({
          showConfirmation: !showConfirmation
        }),
      initUploadTasks:
        ({ parsed }) =>
        () => {
          return {
            parsed: fp.map((entry) => {
              return {
                ...entry,
                taskStatus: TaskStatus.initiated
              };
            })(parsed)
          };
        },
      onTaskStarted:
        ({ parsed }) =>
        ({ identifier }) => {
          return {
            parsed: fp.map((entry) => {
              return entry.identifier === identifier
                ? {
                    ...entry,
                    taskStatus: TaskStatus.updating
                  }
                : entry;
            })(parsed)
          };
        },
      onTaskFinished:
        ({ parsed }) =>
        (success) => {
          return {
            parsed: fp.map((entry) => {
              return entry.taskStatus === TaskStatus.updating
                ? {
                    ...entry,
                    taskStatus: success
                      ? TaskStatus.completed
                      : TaskStatus.failed
                  }
                : entry;
            })(parsed)
          };
        },
      refreshCpdCategorysForUsers:
        ({ parsed }, { industries, mode }) =>
        (userProfiles) => {
          return {
            parsed: fp.flow(
              fp.map((entry) =>
                mapFaseaCpdPoints(entry, industries, userProfiles, mode)
              ),
              fp.map((entry) => {
                return {
                  ...entry,
                  validated: true
                };
              })
            )(parsed)
          };
        }
    }
  ),
  withProps(({ parsed }) => {
    return {
      validatedEntries: fp.filter(({ validated }) => validated)(parsed)
    };
  }),
  withProps(({ parsed, validatedEntries, usersForUpload }) => {
    const userEmails = fp.flow(fp.map('email'), fp.uniq)(parsed);

    const confirmationUserPoints = fp.map(
      ({ user: { email, firstName, lastName } }) => {
        const externalCpds = fp.flow(
          fp.filter((v) => fp.lowerCase(v.email) === fp.lowerCase(email))
        )(validatedEntries);
        return {
          fullName: `${firstName} ${lastName}`,
          email,
          externalCpds
        };
      }
    )(usersForUpload);

    const confirmUserNames = fp.flow(
      fp.flatMap(({ user: { email, firstName, lastName } }) => {
        const uploaded = fp.filter(
          (v) => fp.lowerCase(v.email) === fp.lowerCase(email)
        )(validatedEntries);
        const fullName = `${firstName} ${lastName}`;
        const inconsistentFullNames = fp.flow(
          fp.map((v) => `${v.firstName} ${v.lastName}`),
          fp.uniq,
          fp.filter((n) => fp.lowerCase(n) !== fp.lowerCase(fullName))
        )(uploaded);
        return fp.map(
          (wrongName) =>
            `Inconsistency detected! User (${email})'s name is ${fullName} instead of ${wrongName}`
        )(inconsistentFullNames);
      })
    )(usersForUpload);

    const nextUploadTask = fp.find(
      ({ taskStatus }) => taskStatus === TaskStatus.initiated
    )(validatedEntries);

    const uploadingTask = fp.find(
      ({ taskStatus }) => taskStatus === TaskStatus.updating
    )(validatedEntries);

    const completedCount = fp.flow(
      fp.filter(({ taskStatus }) => taskStatus === TaskStatus.completed),
      fp.get('length')
    )(validatedEntries);
    const failedCount = fp.flow(
      fp.filter(({ taskStatus }) => taskStatus === TaskStatus.failed),
      fp.get('length')
    )(validatedEntries);
    const totalCount = fp.get('length')(validatedEntries);
    const progress = totalCount
      ? `(${completedCount}/${failedCount}/${totalCount})`
      : '';

    const uploadProgressDetails = fp.flow(
      fp.groupBy('email'),
      fp.toPairs,
      fp.map(([email, tasks]) => {
        const user = fp.find(
          ({ user }) => fp.lowerCase(user.email) === fp.lowerCase(email)
        )(usersForUpload);
        const completedUserTasks = fp.filter(
          ({ taskStatus }) => taskStatus === TaskStatus.completed
        )(tasks);
        const failedUserTasks = fp.filter(
          ({ taskStatus }) => taskStatus === TaskStatus.failed
        )(tasks);
        const userProgress = {
          total: tasks.length,
          completed: completedUserTasks.length,
          failed: failedUserTasks.length
        };
        return {
          email,
          user,
          progress: userProgress
        };
      })
    )(validatedEntries);

    return {
      confirmationUserPoints,
      confirmUserNames,
      userEmails,
      nextUploadTask,
      uploadingTask,
      progress,
      uploadProgressDetails
    };
  }),
  withHandlers({
    handleUpload:
      ({ upload, onTaskStarted, allGoals }) =>
      (nextUploadTask, taskGroupId) => {
        const externalCpds = fp.map(
          ({
            id,
            name,
            email,
            date,
            cpdPoints,
            cpdCategoryPoints,
            description,
            provider,
            tpbApproved,
            isRMCPD,
            accreditationDetails
          }) => {
            const externalCpd = {
              userEmail: email,
              timeEarned: format(date, 'yyyy-MM-dd'),
              activityName: name,
              accreditationNumber: id,
              description,
              provider,
              tpbApproved,
              modeOfLearning: modeOfLearning.Online
            };

            const goals = fp.flow(
              fp.filter(({ name }) => {
                const tpbName = 'TPB CPE';
                const rmName = 'RM CPD';

                if (name === tpbName) {
                  return tpbApproved;
                } else if (name === rmName) {
                  return isRMCPD;
                }
                return false;
              }),
              fp.map('id')
            )(allGoals);

            const additionalData = {
              accreditationDetails:
                accreditationDetails === undefined ||
                accreditationDetails.length === 0
                  ? undefined
                  : accreditationDetails
            };

            return {
              externalCpd,
              cpdCategoryPoints: cpdCategoryPoints || [],
              documentedPoints: cpdPoints,
              goals,
              additionalData
            };
          }
        )([nextUploadTask]);
        const data = {
          externalCpds
        };
        const userEmails = fp
          .flow(fp.map('externalCpd.userEmail'))(externalCpds)
          .join(', ');
        onTaskStarted(nextUploadTask);
        const task = {
          adminTaskGroupId: taskGroupId,
          name: 'Kaplan Import',
          description: `Import Kaplan history for ${userEmails}`,
          data: JSON.stringify(data),
          taskType: AdminTaskType.kaplanImport,
          status: AdminTaskStatus.pending
        };
        upload(task);
      }
  }),
  withHandlers({
    exportTemplate:
      ({ mode }) =>
      () => {
        const columns =
          mode === kaplanHistoryUploadMode.mode2022
            ? templateColumns
            : pre2022TemplateColumns;
        const rows =
          mode === kaplanHistoryUploadMode.mode2022 ? [] : pre2022TemplateRows;
        const fileName =
          mode === kaplanHistoryUploadMode.mode2022
            ? 'kaplan-history-template.csv'
            : 'kaplan-history-pre-2022-template.csv';
        downloadBlobStreamFile(
          writeDataToCsvStream(
            getCsvStream({
              header: true,
              columns
            }),
            rows
          ).pipe(getBlobStream()),
          fileName
        );
      }
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      const {
        isUploading,
        userEmails,
        getUsersFromEmails,
        nextUploadTask,
        uploadingTask,
        handleUpload,
        onTaskFinished,
        createTaskGroup,
        csvFile,
        adminTaskGroup,
        isCreatingTaskGroup,
        usersForUpload,
        refreshCpdCategorysForUsers,
        errorMessages,
        setErrorMessages
      } = this.props;

      if (!isUploading && prevProps.isUploading) {
        onTaskFinished(true);
      }

      if (!fp.equals(userEmails)(prevProps.userEmails)) {
        getUsersFromEmails(userEmails);
      }

      if (!fp.equals(usersForUpload)(prevProps.usersForUpload)) {
        refreshCpdCategorysForUsers(usersForUpload);
        setErrorMessages({
          ...errorMessages,
          userNotFoundMsg:
            usersForUpload.length === 0
              ? ['No known user found from the uploaded CSV.']
              : []
        });
      }

      if (!uploadingTask && nextUploadTask) {
        if (!adminTaskGroup) {
          if (!isCreatingTaskGroup) {
            if (csvFile) {
              const fileName = csvFile.name;
              const fileTitle = fileName && fileName.replace('.csv', '');
              const newTaskGroup = {
                name: fileTitle,
                description: `Kaplan History Data Imported`,
                date: new Date()
              };
              createTaskGroup(newTaskGroup);
            }
          }
        } else {
          handleUpload(nextUploadTask, adminTaskGroup.id);
        }
      }
    }
  })
)(KaplanHistoryUpload);


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/cpd-point-portal/kaplan-history-upload.js